// Сгенерённые Zod-схемы DTO (валидация ответов); мапперы разворачивают их в
// доменную форму сущностей.
export * as apiZod from './__generated__/zod.gen'
export {
  autoRedirectToLogin,
  clearLoginAttempt,
  fetchMe,
  hasLoginAttempt,
  loginUrl,
  redirectToLogin,
  redirectToLogout,
  type Session,
  SessionSchema,
  sanitizeInternalPath,
} from './auth'
export { apiClient, lastSessionKind, type SessionKind, sessionExpired } from './client'
export {
  ApiError,
  apiDelete,
  apiGet,
  apiGetBlob,
  apiPatchVoid,
  apiPost,
  apiPostVoid,
  apiPutVoid,
  apiUpload,
} from './request'

// Ленивая обёртка: mock-слой не попадает в prod-бандл (dynamic import),
// а bootstrap ходит через public API сегмента.
export async function startMockWorker(): Promise<void> {
  const mock = await import('./mock')
  await mock.startMockWorker()
}
